// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"86":"0e143925","364":"0e143925","450":"f8d4ba87","906":"0e143925"}[chunkId] + ".chunk.css";
};